<div class="header navbar" *ngIf="!(accessApi.me | isUser : 'fauxbox-user')">
  <div class="header-container">
    <ul class="nav-left">
      <li>
        <a
          class="side-nav-toggle"
          (click)="toggleSideNavCollapse()"
          href="javascript:void(0);"
        >
          <i class="ti-view-grid"></i>
        </a>
      </li>
      <li>
        <a class="" (click)="backClick()" href="javascript:void(0);">
          <i class="ei-rewind"></i>
        </a>
      </li>
      <li>
        <a class="" [routerLink]="['/']" href="javascript:void(0);">
          <i class="ei-home"></i>
        </a>
      </li>
      <li class="pdd-vertical-20">
        <app-egi-breadcrumb
          bgColor="#FFFFFF"
          fontColor="#888da8"
        ></app-egi-breadcrumb>
      </li>
    </ul>
    <ul class="nav-right">
      <li>
        <a
          [class.hidden]="!(accessApi | isUser : 'sales')"
          style="padding-right: 0px !important; padding-top: 1px"
          (click)="creativeModal = true"
          href="javascript:void(0);"
        >
          <i class="ei-picture"></i>
        </a>
      </li>
      <li>
        <a (click)="issueModal = true" href="javascript:void(0);">
          <i class="ei-light-bulb"></i>
        </a>
      </li>
      <li [class.hidden]="accessApi | isUser : 'agent'">
        <div class="" style="width: 300px; margin-top: 13px">
          <ng-select
            id="account-select"
            [ngModel]="efoElevate.selectedDealer | async"
            (ngModelChange)="efoElevate.selectDealer($event)"
            bindLabel="dealer_name"
            [items]="efoElevate.activeDealers | async"
            name="selected_dealer"
            placeholder="Select Dealer"
            ngDefaultControl
          ></ng-select>
        </div>
      </li>
      <li class="user-profile dropdown">
        <a href="" class="dropdown-toggle" data-toggle="dropdown">
          <img
            class="hidden profile-img img-fluid"
            src="assets/images/user.jpg"
          />
          <div class="user-info">
            <span class="name pdd-right-5">{{
              (accessApi.mee | async)?.fullname
            }}</span>
            <i class="ti-angle-down font-size-10"></i>
          </div>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a
              href=""
              [routerLink]="[
                '/admin/user/',
                (accessApi.mee | async)?.user_uuid
              ]"
            >
              <i class="ti-user pdd-right-10"></i>
              <span>Profile</span>
            </a>
          </li>
          <li>
            <a href="" [routerLink]="['/settings/settings']">
              <i class="ti-settings pdd-right-10"></i>
              <span>Settings</span>
            </a>
          </li>
          <li>
            <a href="" [routerLink]="['/settings/settings']">
              <i class="ti-ticket pdd-right-10"></i>
              <span>Issue Tracker</span>
            </a>
          </li>
          <li>
            <a href="" [routerLink]="['/elevate/files']">
              <i class="ti-files pdd-right-10"></i>
              <span>Files</span>
            </a>
          </li>
          <li [ngClass]="{ hidden: !(accessApi | isUser : 'developer') }">
            <a href="" [routerLink]="['/apps/email/email-inbox/1']">
              <i class="ti-email pdd-right-10"></i>
              <span>Inbox</span>
            </a>
          </li>
          <li role="separator" class="divider"></li>
          <li>
            <a href="" (click)="logout($event)">
              <i class="ti-power-off pdd-right-10"></i>
              <span>Logout</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>

<egi-issue-modal
  [show]="issueModal"
  (close)="issueModal = false"
></egi-issue-modal>
<egi-modal [show]="creativeModal" size="md" (close)="creativeModal = false">
  <!-- <div style="display: flex; justify-content: center; align-items: center">
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLScxSwzhLHDMeLZuSbVG4C8-bDOglrMTNc0ujGSI-V2XQydblw/viewform?embedded=true"
      width="640"
      height="1572"
      frameborder="0"
      marginheight="0"
      marginwidth="0"
      >Loading…</iframe
    >
  </div> -->

  <div class="h3 text-center text-orange text-uppercase font-bold">
    Creative Specifics for Dealership
  </div>
  <div class="row d-flex justify-content-center pb-4">
    This form will be sent to the dealer's corresponding Account Manager.
  </div>

  <!-- <div header style="display: flex; justify-content: center">  -->
  <div class="row">
    <div class="col-md-12 d-flex justify-content-center">
      <div
        style="
          font-size: 1.1em;
          color: rgb(34, 34, 34);
          font-variant: all-small-caps;
          padding-bottom: 5px;
          font-weight: 600;
        "
      >
        Dealership
      </div>
    </div>
  </div>
  <div class="row pb-1">
    <div class="col-md-12 d-flex justify-content-center pb-4">
      <div style="width: 300px">
        <ng-select
          id="dealer-select"
          [(ngModel)]="creativeNotes.dealer"
          bindLabel="dealer_name"
          [items]="efoElevate.activeDealers | async"
          name="selected_dealer"
          placeholder="Select Dealer"
          ngDefaultControl
        ></ng-select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-center">
      <div
        style="
          font-size: 1.1em;
          color: rgb(34, 34, 34);
          font-variant: all-small-caps;
          padding-bottom: 5px;
          font-weight: 600;
        "
      >
        Specifics for Sales or Service Creative?
      </div>
    </div>
  </div>
  <div class="row pb-1">
    <div class="col-md-12 d-flex justify-content-center pb-4">
      <div class="form-check pr-4">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="creativeNotes.sales"
          id="flexCheckSales"
        />
        <label class="form-check-label" for="flexCheckSales"> Sales </label>
      </div>
      <div class="form-check pl-4">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="creativeNotes.svc"
          id="flexCheckService"
        />
        <label class="form-check-label" for="flexCheckService"> Service </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-center">
      <div
        style="
          font-size: 1.1em;
          color: rgb(34, 34, 34);
          font-variant: all-small-caps;
          padding-bottom: 5px;
          font-weight: 600;
        "
      >
        Month for Creative
      </div>
    </div>
  </div>
  <div class="row pb-1">
    <div class="col-md-12 d-flex justify-content-center pb-4">
      <div style="width: 150px">
        <ng-select
          id="dealer-select"
          [items]="months"
          bindLabel="name"
          [(ngModel)]="creativeNotes.month"
          name="selected_month"
          placeholder="Select Month"
          ngDefaultControl
        ></ng-select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-center">
      <div
        style="
          font-size: 1.1em;
          color: rgb(34, 34, 34);
          font-variant: all-small-caps;
          padding-bottom: 5px;
          font-weight: 600;
        "
      >
        Description of Creative Specifics
      </div>
    </div>
  </div>
  <div class="row pb-1">
    <div class="col-md-12 d-flex justify-content-center pb-4">
      <div style="width: 450px">
        <textarea
          class="form-control"
          rows="6"
          [(ngModel)]="creativeNotes.notes"
          placeholder="Write the dealer requests here..."
        ></textarea>
      </div>
    </div>
  </div>
  <div (click)="submit()" class="btn btn-primary d-flex justify-content-center">
    <i *ngIf="saving" class="fa fa-spinner fa-spin fa-pulse"></i>
    Submit
  </div>
</egi-modal>
